// @flow
import type { ModelId } from './model';
import type { VariationPair } from './product';
import { makeId } from './model';

export type Scan = {
  id: ModelId,
  code: string,
  keys: ?(string[]),
  error: boolean,
  isLoading: boolean,
  pair: ?VariationPair,
};

// eslint-disable-next-line import/prefer-default-export
export const makeScan = (code: string, pair?: VariationPair): Scan => ({
  id: makeId(),
  code,
  keys: null,
  error: false,
  isLoading: false,
  pair: pair || null,
});
